import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
	templateUrl: '_tpl/delete.html',
})
export class DeleteDialogComp {

	deleted: boolean = false;
	target: string;

	constructor(@Inject(MAT_DIALOG_DATA) public data: any,
		protected dialogRef: MatDialogRef<DeleteDialogComp>) {
		this.target = data
	}

	close(): void {
		this.dialogRef.close(this.deleted)
	}
	onDelete(): void {
		this.deleted = true;
		this.close();
	}
}
